import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { createStore, applyMiddleware, compose } from "redux";
import { Router, browserHistory } from "react-router";
import thunk from "redux-thunk";
import "babel-polyfill";
import logger from "dev/logger";

import rootReducer from "reducers";
import Routes from "routes";

import "../styles/main.scss";
import "../styles/navbar.scss";
import "../styles/footer.scss";
import "../styles/home.scss";
import "../styles/contact.scss";
import "../styles/gallery.scss";
import "../styles/fire_safety.scss";

let store = null;

const middleware = applyMiddleware(thunk);
store = createStore(
	rootReducer,
	middleware
);

ReactDOM.render(
	<Provider store={ store }>
		<Router history={ browserHistory } routes={ Routes } />
	</Provider>,
	document.getElementById("root")
);



// WEBPACK FOOTER //
// ./js/index.js